import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import { SideEditOptions } from "../../../types/elements";
const ElementColorImage = ({ editorKey, renderElement, elementId, children, className = "", ...props }) => {
    const containerBgRender = renderElement.renderBackgroundImage(editorKey, "backgroundImage");
    const backgroundType = renderElement.renderProp(editorKey, "background-type")?.value;
    return (_jsxs("div", { "editor-elementid": elementId, "editor-key": editorKey, ...containerBgRender, ...renderElement.renderClassName("container-1", classNames("relative", className)), ...renderElement.renderAttributeOptions([
            {
                type: SideEditOptions.Select,
                config: {
                    key: "background-type",
                    label: "Achtergrond type",
                    defaultValue: "color",
                    open: true,
                    selectOptions: [
                        {
                            value: "color",
                            label: "Kleur",
                        },
                        {
                            value: "image",
                            label: "Afbeelding",
                        },
                    ],
                },
            },
            {
                type: SideEditOptions.BackgroundImage,
                config: { key: "backgroundimage", open: false },
            },
        ], "container-1"), children: [backgroundType === "image" && (_jsx("div", { className: "absolute inset-0", children: _jsx("img", { "editor-focuskey": editorKey, className: "h-full w-full object-cover opacity-60", src: containerBgRender["src"] || "" }) })), children] }));
};
export default ElementColorImage;
//# sourceMappingURL=ElementColorImage.js.map